module.exports = __webpack_public_path__ + "static/media/App-Background.6f6b315a.jpg";